import React from "react";
import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Checkbox from "@mui/material/Checkbox";

function MultiSelectCheckbox({ setting, setParentState, styles = {} }) {
  return (
    <Box sx={{ marginBottom: "2rem", ...styles }}>
      <FormGroup sx={{ display: "flex", flexDirection: "row" }}>
        {setting.field_value.map((field, index) => (
          <FormControlLabel
            control={
              <Checkbox
                checked={field.value}
                onChange={(event) => {
                  const updatedFieldValue = [...setting.field_value];
                  updatedFieldValue[index].value = event.target.checked;
                  setParentState(updatedFieldValue);
                }}
              />
            }
            label={field.display}
          />
        ))}
      </FormGroup>
    </Box>
  );
}

export default MultiSelectCheckbox;
